import { ReactNode } from "react";
import { atomic } from "../atomic.css";
import { Multiplier } from "../multiplier-counter";

export function KeywordItem(props: {
  name: string;
  summary: ReactNode;
  icon: ReactNode;
  standalone?: boolean;
  tag?: "div" | "li";
  count?: number;
}) {
  const Tag = props.tag ?? "div";

  return (
    <Tag
      className={atomic({
        display: "grid",
        gridTemplateColumns: "fraction-auto",
        alignItems: "center",
        gap: 16,
        borderBlockStart: props.standalone ? "solid" : "none",
        borderBlockEnd: {
          default: "dashed",
          last: props.standalone ? "dashed" : "none",
        },
        paddingBlock: 16,
      })}
    >
      <div
        className={atomic({
          alignSelf: "stretch",
        })}
      >
        <div
          className={atomic({
            fontFamily: "arboria",
            fontStyle: "italic",
            textTransform: "uppercase",
            fontWeight: "black",
          })}
        >
          {props.name}

          {props.count && props.count > 1 && (
            <>
              {" "}
              <Multiplier count={props.count} />
            </>
          )}
        </div>

        <div
          className={atomic({
            fontSize: 14,
            marginBlockStart: 6,
            lineHeight: 1.5,
          })}
        >
          {props.summary}
        </div>
      </div>

      {props.icon}
    </Tag>
  );
}
